export default __webpack_public_path__ + "static/media/l1-p2.ec97564e.svg";